export default __webpack_public_path__ + "static/image4-076c31e52e4bd1ed4610befd44e60b8d.jpg";